<template>
    <div class="m-0 pt-2 bg-color-light">
        <div class="container mt-2">
            <div  v-scroll-reveal>
                <h3><span class="bold900 color-vino1">SALA</span> <span class="bold300 color-vino1"> DE PRENSA</span></h3>
                <div class="lineas"></div>
                <div class="mt-1 linea2"></div>
            </div>
            <!-- ==================APARTADO EN CONSTRUCCIÓN================================================================================ -->

            <div v-if="post_recientes">
                <div class="p-3 pb-3 mt-0">
                    <div class="row d-flex align-items-stretch justify-content-between">
                        <div v-for="(item, i) in lastPost" :key="i" class="col-xs-12 col-sm-6 col-md-4 d-flex align-items-stretch" v-scroll-reveal>
                            <router-link :to="{name: 'detalle', params: {id: post_recientes[item-1].idarticulo, titular: titularURL(post_recientes[item-1].titulo)} }"  class="d-flex align-items-stretch">
                                <div class="card">
                                    <!-- <p>{{ post_recientes[item-1].url_thumnail }}</p> -->
                                    <!-- Valida si la imagen es null o si tiene imagen -->

                                    <img v-if="post_recientes[item-1].url_recurso" :src="post_recientes[item-1].url_recurso" class="card-img-top">
                                    <!-- <img v-if="post_recientes[item-1].url_thumnail" :src="post_recientes[item-1].url_thumnail" class="card-img-top"> -->
                                    <img v-else src="@/assets/imagenes/sin_imagen.png" class="card-img-top">

                                    <div class="card-body">
                                        <h5>{{post_recientes[item-1].titulo}} </h5>
                                        <p class="text-muted">{{post_recientes[item-1].fecha_articulo}}  - {{(post_recientes[item-1].idclasificacion == 1)? 'Comunicado' : 'Boletin'}}</p>
                                        <p class="card-text"> {{post_recientes[item-1].resumen}} </p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="mt-3 text-center">
                        <router-link :to="{name: 'listado'}" class="btn btn-vino-o" style="border-radius:22px;">
                                Ver más
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import axios from "axios";
import { mapMutations } from 'vuex'
export default({
    data: function(){
        return{
            url: this.$urlServidor+'SalaDePrensa/api/api/Sala/',
            datos: null,
            lista_anios: [],
            post_recientes: null,
            lastPost: 0
        }
    },
    methods:{
        ...mapMutations(['add_anio', 'add_articulo']),
        /** entra una cadena, ejm: 'titular de prensa', reemplaza espaciados
         * @returns 'titular-de-prensa'
         */
        titularURL(titulo){
            let tituloNuevo = titulo;
            let huboEspacio = true;

            while(huboEspacio){
                if(tituloNuevo.indexOf(' ') > 0){
                    tituloNuevo = tituloNuevo.replace(' ', '-');
                }
                else huboEspacio = false;
            }
            return tituloNuevo;

        },

        /***Obtengo los años con Articulos* */
        traerAnios(){
             axios.get(this.url+'Anios')
             .then(response =>{
                 this.datos = response.data;
                 this.getPostRecientes();
             })
        },
        //Obtengo el año más recientes con articulos
        getPostRecientes(){
            axios.get(this.url+'Articulos/'+this.datos[0].anio)
            .then(response => {
                this.post_recientes = response.data;
                // console.log('this.post_recientes', this.post_recientes.length);
                this.lastPost = (this.post_recientes.length <3)? this.post_recientes.length : 3;


                // console.log(this.post_recientes);
                // console.log("Lista de post recientes (OJO ESTO NOS SERVIRÁ)", this.post_recientes);
            })
        },

    },
    created(){
        this.traerAnios();
        // INICIALIZO ESTAS VARIABLES GLOBALES DESDE
        //BOLETIN OFICIAL PARA QUE PASE LA VALIDACION
        //DE VISTAS EN PRENSA
        this.add_anio(1);
        this.add_articulo(1);
    }

})
</script>
<style scoped>

.none{ display: none !important; }
.show{ display: column !important; }
.bg-color-light{ background: #f3f5f6 !important}

.card{
    padding-top: .4rem;
    border: .5px solid #fefefe;
    border-radius: 0;
    box-shadow: 1px 10px 20px -10px rgba(0,0,0,0.6);
    margin-top: .9rem;
}
.card:hover{  box-shadow: 0px 10px 30px -10px rgba(0,0,0,0.6); }
.card-body h5{ color: #621132; }

.text-muted{ font-size: .75rem; }

a{ color: #212529 }
a:hover{
    color: #212529;
    text-decoration: none;
}



</style>

